const SoFormStepPayment = {
  nameForData: 'SO_FORM_STEP_PAYMENT',
  hideHeader: true,
};

export default SoFormStepPayment;
